import { Slider, Tooltip } from "antd"
import { useContext, useEffect, useState } from "react"
import styles from './index.module.scss'
import { GenerateContext } from "../../../hooks/GenerateContext"

// props.reverse: 
//   true-与相似度负相关，value=0在最右边；
//   false-与相似度正相关，value=1在最右边；
const StrengthSlider = (props) => {
    const {
        refImgStrength, setRefImgStrength
    } = useContext(GenerateContext)

    const onChange = (value) => {
        setRefImgStrength(value)
    }
    const formatter = (value) => {
        return value
    }
    return (
        <div className={styles.StrengthSlider}>
            {
                props.title &&
                <p>
                    <span>{props.title}</span>
                </p>
            }
            <Slider
                marks={props.marks}
                disabled={props.disabled}
                defaultValue={refImgStrength}
                value={refImgStrength}
                min={props.min || 0}
                max={props.max || 1}
                step={props.step || 0.1}
                tooltip={{formatter: props.showTooltip ? formatter : null}}
                onChange={onChange}
            />
            <p style={{ justifyContent: 'space-between', marginTop: 10 }}>
                <span>{props.leftTips || '更加自由'}</span>
                <span>{props.rightTips || '非常相似'}</span>
            </p>
        </div>
    )
}

export default StrengthSlider
